/**
 * @author: Tolga MALKOC | ghostlexly@gmail.com
 * @type {{watch: mercure.watch}}
 */

let mercure = {
	/**
	 * Receive a topic url to watch and a function to call.
	 * Example of topic url: "https://{host}:{port}/api/suppliers/{id}"
	 *
	 * @param parent
	 * @param topicUrl
	 * @param functionToCall
	 * @param callFunctionOnStart
	 */
	watch: function (parent, topicUrl, functionToCall, callFunctionOnStart = true) {
		let eventSource = null;
		const urlSearchParams = new URLSearchParams();
		urlSearchParams.append('topic', topicUrl);
		urlSearchParams.append('topic', 'https://{host}:{port}' + topicUrl);
		urlSearchParams.append('topic', 'https://{host}' + topicUrl);

		let timer1 = setInterval(function () {
			if (parent.$el.offsetWidth === 0 && parent.$el.offsetHeight === 0) {
				// Caller object is not visible anymore on the DOM
				eventSource.close();
				clearTimeout(timer1);
			}
		}, 5000);

		// call the function one time on start
		if (callFunctionOnStart) {
			functionToCall.call(parent);
		}

		// watch
		eventSource = new EventSource(`/.well-known/mercure?${urlSearchParams.toString()}`);
		eventSource.onmessage = functionToCall.bind(parent);
	},
};

export default mercure;
